import { HRIS_ACCESS_RIGHTS } from "@/constants/AccessRights";
import { lazy } from "react";

const Dashboards_Main = lazy(() => import("@/pages/HRIS/Dashboards/MainDashboard"));
const Dashboards_Employee = lazy(() => import("@/pages/HRIS/Dashboards/EmployeeDashboard"));

const HRIS_SelfService_MyAttendance = lazy(() => import("@/pages/HRIS/SelfService/MyAttendance/index"));
const HRIS_SelfService_MyGoalSettings = lazy(() => import("@/pages/HRIS/SelfService/MyGoalSettings/index"));
const HRIS_SelfService_MyLearningAndDevelopment = lazy(() => import("@/pages/HRIS/SelfService/MyLearningAndDevelopment/index"));
const HRIS_SelfService_MyLeaveSummary = lazy(() => import("@/pages/HRIS/SelfService/MyLeaveSummary/index"));

const HRIS_HR_Employees = lazy(() => import("@/pages/HRIS/HR/Employees/index"));
const HRIS_HR_Plantilla = lazy(() => import("@/pages/HRIS/HR/Plantilla"));
const HRIS_HR_LeaveSummary = lazy(() => import("@/pages/HRIS/HR/LeaveSummary/index"));
const HRIS_HR_Disciplinary = lazy(() => import("@/pages/HRIS/HR/Disciplinary"));
const HRIS_HR_Separation = lazy(() => import("@/pages/HRIS/HR/Separation"));

const HRIS_Recruitment_Applicants = lazy(() => import("@/pages/HRIS/Recruitment/Applicant/Applicants/index"));
const HRIS_Recruitment_Applicants_Exams = lazy(() => import("@/pages/HRIS/Recruitment/Applicant/ApplicantExams/index"));
const HRIS_Recruitment_Applicants_Interviews = lazy(() => import("@/pages/HRIS/Recruitment/Applicant/ApplicantInterviews/index"));
const HRIS_Recruitment_Jobs = lazy(() => import("@/pages/HRIS/Recruitment/Job/Jobs/index"));
const HRIS_Recruitment_Jobs_Details = lazy(() => import("@/pages/HRIS/Recruitment/Job/Jobs/Components/Overview/index"));
const HRIS_Recruitment_Jobs_Contracts = lazy(() => import("@/pages/HRIS/Recruitment/Job/JobContracts/index"));

const HRIS_WorkforceDevelopment_GoalSettings = lazy(() => import("@/pages/HRIS/WorkforceDevelopment/GoalSettings/index"));
const HRIS_WorkforceDevelopment_LearningAndDevelopment = lazy(() => import("@/pages/HRIS/WorkforceDevelopment/LearningAndDevelopment/index"));
const HRIS_WorkforceDevelopment_PerformanceEvaluation = lazy(() => import("@/pages/HRIS/WorkforceDevelopment/PerformanceEvaluation/index"));
const HRIS_WorkforceDevelopment_RewardAndRecognition = lazy(() => import("@/pages/HRIS/WorkforceDevelopment/RewardAndRecognition/index"));

const HRIS_EmployeeAttendance = lazy(() => import("@/pages/HRIS/EmployeeAttendance/index"));

const HRIS_Transactions = lazy(() => import("@/pages/HRIS/Transactions/index"));
const HRIS_Transactions_EmploymentCertificateRequests = lazy(() => import("@/pages/HRIS/Transactions/EmploymentCertificateRequests/index"));
const HRIS_Transactions_202FileCopy = lazy(() => import("@/pages/HRIS/Transactions/File201CopyRequests/index"));
const HRIS_Transactions_LeaveRequests = lazy(() => import("@/pages/HRIS/Transactions/LeaveRequests/index"));
const HRIS_Transactions_OvertimeRequests = lazy(() => import("@/pages/HRIS/Transactions/OvertimeRequests/index"));
const HRIS_Transactions_ServiceRecordCopyRequests = lazy(() => import("@/pages/HRIS/Transactions/ServiceRecordCopyRequests/index"));
const HRIS_Transactions_TrainingRequests = lazy(() => import("@/pages/HRIS/Transactions/TrainingRequests/index"));
const HRIS_Transactions_WorkFromHomeRequests = lazy(() => import("@/pages/HRIS/Transactions/WorkFromHomeRequests/index"));
const HRIS_Transactions_ChangeLocations = lazy(() => import("@/pages/HRIS/Transactions/ChangeLocations/index"));

const HRIS_Reports = lazy(() => import("@/pages/HRIS/Reports/index"));

const HRIS_StaticData = lazy(() => import("@/pages/HRIS/StaticData/index"));
const HRIS_StaticData_Exams = lazy(() => import("@/pages/HRIS/StaticData/Exams"));
const HRIS_StaticData_Education_Level = lazy(() => import("@/pages/HRIS/StaticData/EducationLevels"));
const HRIS_StaticData_Training_Target = lazy(() => import("@/pages/HRIS/StaticData/TrainingTargets"));
const HRIS_StaticData_Training_Program = lazy(() => import("@/pages/HRIS/StaticData/TrainingPrograms"));
const HRIS_StaticData_Employment_Types = lazy(() => import("@/pages/HRIS/StaticData/EmploymentTypes"));
const HRIS_StaticData_Holiday_Types = lazy(() => import("@/pages/HRIS/StaticData/HolidayTypes"));
const HRIS_StaticData_Leave_Types = lazy(() => import("@/pages/HRIS/StaticData/LeaveTypes"));
const HRIS_StaticData_Nationalities = lazy(() => import("@/pages/HRIS/StaticData/Nationalities"));
const HRIS_StaticData_Offices = lazy(() => import("@/pages/HRIS/StaticData/Offices"));
const HRIS_StaticData_Positions = lazy(() => import("@/pages/HRIS/StaticData/Positions"));
const HRIS_StaticData_RelationshipTypes = lazy(() => import("@/pages/HRIS/StaticData/RelationshipTypes"));
const HRIS_StaticData_SalaryGrades = lazy(() => import("@/pages/HRIS/StaticData/SalaryGrades"));
const HRIS_StaticData_SalaryTypes = lazy(() => import("@/pages/HRIS/StaticData/SalaryTypes"));
const HRIS_StaticData_Schools = lazy(() => import("@/pages/HRIS/StaticData/Schools"));
const HRIS_StaticData_Seperation_Types = lazy(() => import("@/pages/HRIS/StaticData/SeparationTypes"));
const HRIS_StaticData_Seperation_Type_Categories = lazy(() => import("@/pages/HRIS/StaticData/SeparationTypeCategories"));
const HRIS_StaticData_Service_Record_Types = lazy(() => import("@/pages/HRIS/StaticData/ServiceRecordTypes"));
const HRIS_StaticData_Skills = lazy(() => import("@/pages/HRIS/StaticData/Skills"));
const HRIS_StaticData_WorkSchedules = lazy(() => import("@/pages/HRIS/StaticData/WorkSchedules"));

export var hrisRoutes = [
    { path: "/index", component: <Dashboards_Employee /> },
    { path: "/hris/dashboards/main", component: <Dashboards_Main />, permissionTypeId: [] },
    { path: "/hris/dashboards/employee", component: <Dashboards_Employee />, permissionTypeId: [] },

    // Self-Service
    { path: "/hris/self-service/my-attendance", component: <HRIS_SelfService_MyAttendance />, permissionTypeId: [] },
    { path: "/hris/self-service/my-goal-settings", component: <HRIS_SelfService_MyGoalSettings />, permissionTypeId: [] },
    { path: "/hris/self-service/my-learning-development", component: <HRIS_SelfService_MyLearningAndDevelopment />, permissionTypeId: [] },
    { path: "/hris/self-service/my-leave-summary", component: <HRIS_SelfService_MyLeaveSummary />, permissionTypeId: [] },

    // HR
    { path: "/hris/hr/employees", component: <HRIS_HR_Employees />, permissionTypeId: [] },
    { path: "/hris/hr/plantilla", component: <HRIS_HR_Plantilla />, permissionTypeId: [] },
    { path: "/hris/hr/leave-summary", component: <HRIS_HR_LeaveSummary />, permissionTypeId: [] },
    { path: "/hris/hr/disciplinary", component: <HRIS_HR_Disciplinary />, permissionTypeId: [] },
    { path: "/hris/hr/separation", component: <HRIS_HR_Separation />, permissionTypeId: [] },

    // Recruitment
    { path: "/hris/recruitment/applicants", component: <HRIS_Recruitment_Applicants />, permissionTypeId: [] },
    { path: "/hris/recruitment/applicants/exams", component: <HRIS_Recruitment_Applicants_Exams />, permissionTypeId: [] },
    { path: "/hris/recruitment/applicants/interviews", component: <HRIS_Recruitment_Applicants_Interviews />, permissionTypeId: [] },
    { path: "/hris/recruitment/jobs", component: <HRIS_Recruitment_Jobs />, permissionTypeId: [] },
    { path: "/hris/recruitment/jobs/details", component: <HRIS_Recruitment_Jobs_Details />, permissionTypeId: [] },
    { path: "/hris/recruitment/contracts", component: <HRIS_Recruitment_Jobs_Contracts />, permissionTypeId: [] },

    // Workforce Development
    { path: "/hris/workforce-development/learning-development", component: <HRIS_WorkforceDevelopment_LearningAndDevelopment />, permissionTypeId: [] },
    { path: "/hris/workforce-development/goal-settings", component: <HRIS_WorkforceDevelopment_GoalSettings />, permissionTypeId: [] },
    { path: "/hris/workforce-development/performance-evaluation", component: <HRIS_WorkforceDevelopment_PerformanceEvaluation />, permissionTypeId: [] },
    { path: "/hris/workforce-development/reward-recognition", component: <HRIS_WorkforceDevelopment_RewardAndRecognition />, permissionTypeId: [] },

    // Time & Leave
    { path: "/hris/employee-attendance", component: <HRIS_EmployeeAttendance />, permissionTypeId: [] },

    // Requests

    {
        path: "/hris/transactions/coe", component: <HRIS_Transactions_EmploymentCertificateRequests />,
        permissionTypeId: [
            HRIS_ACCESS_RIGHTS.HRIS_TRANSACTIONS_CERTIFICATEOFEMPLOYMENT_VIEWER,
            HRIS_ACCESS_RIGHTS.HRIS_TRANSACTIONS_CERTIFICATEOFEMPLOYMENT_REQUESTOR,
            HRIS_ACCESS_RIGHTS.HRIS_TRANSACTIONS_CERTIFICATEOFEMPLOYMENT_APPROVER,
        ],
    },
    {
        path: "/hris/transactions/leave-requests", component: <HRIS_Transactions_LeaveRequests />,
        permissionTypeId: [
            HRIS_ACCESS_RIGHTS.HRIS_TRANSACTIONS_LEAVE_VIEWER,
            HRIS_ACCESS_RIGHTS.HRIS_TRANSACTIONS_LEAVE_REQUESTOR,
            HRIS_ACCESS_RIGHTS.HRIS_TRANSACTIONS_LEAVE_APPROVER,
        ],
    },

    // // Transactions — index
    // {
    //     path: "/hris/transactions", component: <HRIS_Transactions />,
    //     permissionTypeId: [
    //         HRIS_ACCESS_RIGHTS.HRIS_TRANSACTIONS_CERTIFICATEOFEMPLOYMENT_VIEWER,
    //         HRIS_ACCESS_RIGHTS.HRIS_TRANSACTIONS_201FILECOPY_VIEWER,
    //         HRIS_ACCESS_RIGHTS.HRIS_TRANSACTIONS_LEAVE_VIEWER,
    //         HRIS_ACCESS_RIGHTS.HRIS_TRANSACTIONS_OVERTIME_VIEWER,
    //         HRIS_ACCESS_RIGHTS.HRIS_TRANSACTIONS_SERVICERECORDCOPY_VIEWER,
    //         HRIS_ACCESS_RIGHTS.HRIS_TRANSACTIONS_TRAINING_VIEWER,
    //         HRIS_ACCESS_RIGHTS.HRIS_TRANSACTIONS_WORKFROMHOME_VIEWER,
    //     ],
    // },

    // Transactions — detail pages
    {
        path: "/hris/transactions/change-location-requests", component: <HRIS_Transactions_ChangeLocations />,
        permissionTypeId: [], // no matching right yet
    },

    {
        path: "/hris/transactions/file201CopyRequests", component: <HRIS_Transactions_202FileCopy />,
        permissionTypeId: [
            HRIS_ACCESS_RIGHTS.HRIS_TRANSACTIONS_201FILECOPY_VIEWER,
            HRIS_ACCESS_RIGHTS.HRIS_TRANSACTIONS_201FILECOPY_REQUESTOR,
            HRIS_ACCESS_RIGHTS.HRIS_TRANSACTIONS_201FILECOPY_APPROVER,
        ],
    },

    {
        path: "/hris/transactions/overtimeRequests", component: <HRIS_Transactions_OvertimeRequests />,
        permissionTypeId: [
            HRIS_ACCESS_RIGHTS.HRIS_TRANSACTIONS_OVERTIME_VIEWER,
            HRIS_ACCESS_RIGHTS.HRIS_TRANSACTIONS_OVERTIME_REQUESTOR,
            HRIS_ACCESS_RIGHTS.HRIS_TRANSACTIONS_OVERTIME_APPROVER,
        ],
    },
    {
        path: "/hris/transactions/serviceRecordCopyRequests", component: <HRIS_Transactions_ServiceRecordCopyRequests />,
        permissionTypeId: [
            HRIS_ACCESS_RIGHTS.HRIS_TRANSACTIONS_SERVICERECORDCOPY_VIEWER,
            HRIS_ACCESS_RIGHTS.HRIS_TRANSACTIONS_SERVICERECORDCOPY_REQUESTOR,
            HRIS_ACCESS_RIGHTS.HRIS_TRANSACTIONS_SERVICERECORDCOPY_APPROVER,
        ],
    },
    {
        path: "/hris/transactions/trainingrequests", component: <HRIS_Transactions_TrainingRequests />,
        permissionTypeId: [
            HRIS_ACCESS_RIGHTS.HRIS_TRANSACTIONS_TRAINING_VIEWER,
            HRIS_ACCESS_RIGHTS.HRIS_TRANSACTIONS_TRAINING_REQUESTOR,
            HRIS_ACCESS_RIGHTS.HRIS_TRANSACTIONS_TRAINING_APPROVER,
        ],
    },
    {
        path: "/hris/transactions/workFromHomeRequests", component: <HRIS_Transactions_WorkFromHomeRequests />,
        permissionTypeId: [
            HRIS_ACCESS_RIGHTS.HRIS_TRANSACTIONS_WORKFROMHOME_VIEWER,
            HRIS_ACCESS_RIGHTS.HRIS_TRANSACTIONS_WORKFROMHOME_REQUESTOR,
            HRIS_ACCESS_RIGHTS.HRIS_TRANSACTIONS_WORKFROMHOME_APPROVER,
        ],
    },

    // Reports
    { path: "/hris/reports", component: <HRIS_Reports />, permissionTypeId: [] },

    // Settings — index
    {
        path: "/hris/settings", component: <HRIS_StaticData />,
        permissionTypeId: [
            HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_EDUCATIONLEVELS,
            HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_EMPLOYMENTTYPES,
            HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_HOLIDAYTYPES,
            HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_LEAVETYPES,
            HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_NATIONALITIES,
            HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_OFFICES,
            HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_POSITIONS,
            HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_RELATIONSHIPTYPES,
            HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_SALARYMATRIX,
            HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_SALARYTYPES,
            HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_SCHOOLS,
            HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_SEPARATIONTYPES,
            HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_SERVICERECORDTYPES,
            HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_SKILLS,
            HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_TRAININGPROGRAMS,
            HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_TRAININGTARGETS,
            HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_WORKSCHEDULES,
        ],
    },

    // Settings — detail pages
    { path: "/hris/settings/exams", component: <HRIS_StaticData_Exams />, permissionTypeId: [] },

    { path: "/hris/settings/education-level", component: <HRIS_StaticData_Education_Level />, permissionTypeId: [HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_EDUCATIONLEVELS] },
    { path: "/hris/settings/employment-types", component: <HRIS_StaticData_Employment_Types />, permissionTypeId: [HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_EMPLOYMENTTYPES] },
    { path: "/hris/settings/holiday-types", component: <HRIS_StaticData_Holiday_Types />, permissionTypeId: [HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_HOLIDAYTYPES] },
    { path: "/hris/settings/leave-types", component: <HRIS_StaticData_Leave_Types />, permissionTypeId: [HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_LEAVETYPES] },
    { path: "/hris/settings/mandatory-training-targets", component: <HRIS_StaticData_Training_Target />, permissionTypeId: [HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_TRAININGTARGETS] },
    { path: "/hris/settings/nationalities", component: <HRIS_StaticData_Nationalities />, permissionTypeId: [HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_NATIONALITIES] },
    { path: "/hris/settings/offices", component: <HRIS_StaticData_Offices />, permissionTypeId: [HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_OFFICES] },
    { path: "/hris/settings/positions", component: <HRIS_StaticData_Positions />, permissionTypeId: [HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_POSITIONS] },
    { path: "/hris/settings/relationship-types", component: <HRIS_StaticData_RelationshipTypes />, permissionTypeId: [HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_RELATIONSHIPTYPES] },
    { path: "/hris/settings/salary-grades", component: <HRIS_StaticData_SalaryGrades />, permissionTypeId: [HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_SALARYMATRIX] },
    { path: "/hris/settings/salary-types", component: <HRIS_StaticData_SalaryTypes />, permissionTypeId: [HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_SALARYTYPES] },
    { path: "/hris/settings/schools", component: <HRIS_StaticData_Schools />, permissionTypeId: [HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_SCHOOLS] },
    { path: "/hris/settings/seperation-types", component: <HRIS_StaticData_Seperation_Types />, permissionTypeId: [HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_SEPARATIONTYPES] },
    { path: "/hris/settings/seperation-type-categories", component: <HRIS_StaticData_Seperation_Type_Categories />, permissionTypeId: [HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_SEPARATIONTYPECATEGORIES] },
    { path: "/hris/settings/service-record-types", component: <HRIS_StaticData_Service_Record_Types />, permissionTypeId: [HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_SERVICERECORDTYPES] },
    { path: "/hris/settings/skills", component: <HRIS_StaticData_Skills />, permissionTypeId: [HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_SKILLS] },
    { path: "/hris/settings/training-programs", component: <HRIS_StaticData_Training_Program />, permissionTypeId: [HRIS_ACCESS_RIGHTS.HRIS_STATICDATA_TRAININGPROGRAMS] },
    { path: "/hris/settings/work-schedules", component: <HRIS_StaticData_WorkSchedules />, permissionTypeId: [] },

];